module.exports = __webpack_public_path__ + "static/media/calendario.67fa09f8.svg";